module.exports = __webpack_public_path__ + "static/about-hero-e2367bad1f83f2f078bd167eab151258.png";